import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const CopyToClipboardCircle = ({
  height = "24",
  width = "24",
  fill = theme.colors["botticelli-blue"],
  stroke = theme.colors["nepal-blue"],
}: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width={width} height={height} rx="12" fill={fill} fillOpacity="0.5" />
      <g clipPath="url(#clip0_56_467)">
        <path
          d="M11.125 6.16832C10.7312 6.17365 10.4948 6.19645 10.3037 6.29385C10.0841 6.4057 9.90567 6.58418 9.79382 6.8037C9.69642 6.99484 9.67362 7.23124 9.66829 7.62502M16.375 6.16832C16.7688 6.17365 17.0052 6.19645 17.1963 6.29385C17.4158 6.4057 17.5943 6.58418 17.7062 6.8037C17.8036 6.99484 17.8264 7.23124 17.8317 7.62501M17.8317 12.875C17.8264 13.2688 17.8036 13.5052 17.7062 13.6963C17.5943 13.9159 17.4158 14.0943 17.1963 14.2062C17.0052 14.3036 16.7688 14.3264 16.375 14.3317M17.8333 9.66668V10.8333M13.1667 6.16669H14.3333M8.03332 17.8334H12.4667C13.1201 17.8334 13.4467 17.8334 13.6963 17.7062C13.9158 17.5943 14.0943 17.4159 14.2062 17.1963C14.3333 16.9468 14.3333 16.6201 14.3333 15.9667V11.5334C14.3333 10.88 14.3333 10.5533 14.2062 10.3037C14.0943 10.0842 13.9158 9.9057 13.6963 9.79385C13.4467 9.66669 13.1201 9.66669 12.4667 9.66669H8.03332C7.37993 9.66669 7.05323 9.66669 6.80367 9.79385C6.58415 9.9057 6.40567 10.0842 6.29382 10.3037C6.16666 10.5533 6.16666 10.88 6.16666 11.5334V15.9667C6.16666 16.6201 6.16666 16.9468 6.29382 17.1963C6.40567 17.4159 6.58415 17.5943 6.80367 17.7062C7.05323 17.8334 7.37993 17.8334 8.03332 17.8334Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_56_467">
          <rect width="14" height="14" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CopyToClipboardCircle;
